<template>
    <div class="wrap-content ocr-config-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-4">
                    <h2>Customer On Boarding</h2>
                </div>
            </div>
        </div>

        <div class="config-card-switch">
            <div class="row">
                <div v-if="!showPageLoader" class="col-lg-12">
                    <div class="card custom-card">
                        <div class="fields-area" v-if="'switch' in formData">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">OCR Switch</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group id="populatedata"
                                            label="Use OCR to populate Data in Registration Form"
                                            label-for="populatedata">
                                            <b-form-radio-group v-model="formData.switch" :options="ocrSwitch"
                                                name="switch"></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fields-area" v-if="'restrictDuplicateCustomers' in formData">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">ID Document Number</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group label="Restrict duplicate ID document numbers"
                                            label-for="restrict-duplicate-customers">
                                            <b-form-radio-group v-model="formData.restrictDuplicateCustomers
                    " :options="documentOptions" name="radio-options"></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fields-area" v-if="'restrictBulkOnboarding' in formData">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Bulk Customer Onboarding</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group label="Restrict bulk customer onboarding feature"
                                            label-for="restrict-bulk-customer-onboarding">
                                            <b-form-radio-group v-model="formData.restrictBulkOnboarding
                    " :options="bulkOboardingOptions" name="bulk-options"></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fields-area" v-if="'restrictIndividualScreening' in formData">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Restrict Individual Screening</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group label="Restrict individual screening feature"
                                            label-for="restrict-individual-screening-onboarding">
                                            <b-form-radio-group v-model="formData.restrictIndividualScreening
                    " :options="individualScreeningOptions" name="individual-options"></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fields-area" v-if="'restrictCorporateScreening' in formData">
                            <div class="brand-color-area">
                                <h5 class="m-b-30">Restrict Company Screening</h5>
                                <div class="row">
                                    <div class="col-lg-12 form-radio">
                                        <b-form-group label="Restrict Company screening feature"
                                            label-for="restrict-corporate-screening-onboarding">
                                            <b-form-radio-group v-model="formData.restrictCorporateScreening
                    " :options="corporateScreeningOptions" name="corporate-options"></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <b-button type="submit" variant="primary" :class="loading ? 'disabled' : ''"
                                    @click.prevent="
                    updateOnboardingConfiguration()
                    ">
                                    <span class="btn-text">UPDATE</span>
                                    <span class="loader"></span>
                                </b-button>
                                <base-toast></base-toast>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- When data is loading -->
                <base-table-spinner v-if="showPageLoader"></base-table-spinner>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const viewOcrResource = new resource('configurations/ocr')
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            showPageLoader: true,
            query: {
                dataSegmentId: localStorage.getItem('dataSegmentId'),
            },
            formData: {
                // switch: false,
                // restrictDuplicateCustomers: false,
            },
            ocrSwitch: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            documentOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            bulkOboardingOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            individualScreeningOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            corporateScreeningOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            ocrList: [],
            resourceApi: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'getConfigurationOcrData',
            'dataSegmentId',
            'loading',
            'data',
        ]),
    }, // End of Component > mounted

    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getOcrData()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getOcrData()
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getOcrData() {
            if (this.dataSegmentId) {
                this.query.dataSegmentId = this.dataSegmentId
            }
            let { data } = await viewOcrResource.list(this.query)
            this.formData = data.data
            // this.formData = this.getConfigurationOcrData || {}
            // this.$store.commit('setConfigurationOcrData', this.formData)
            this.showPageLoader = false
        },

        async updateOnboardingConfiguration() {
            try {
                // update on boarding configuration
                this.$store.commit('setLoading', true)
                let { data } = await viewOcrResource.update(
                    this.formData._id,
                    this.formData
                )

                await viewOcrResource.list(this.query)
                this.$store.commit('setLoading', false)
                this.$store.commit('setSuccess', data.message)
            } catch (error) {
                this.$store.commit(
                    'setError',
                    'There is an error update on boarding configuration'
                )
            }
        },
    },
} // End of export default
</script>
